/* eslint-disable no-undef */
import React, { useEffect, Fragment, useContext } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import { CLOSE_RESOURCE } from 'constants/actionTypes';

import { saveResourceModal, closeModal, linkObjects } from 'actions/modalActions';
import { setAlert, hideAlert } from 'actions/viewActions';
import { validateResource } from 'validation/resourceValidation';
import { getActiveResource, canCloseResource } from 'helpers/modalHelpers';
import { getUniquenessMessage } from 'actions/validationActions';

import Loading from 'components/common/Loading';
import SaveButton from 'components/common/SaveButton';
import LocaleContext from 'constants/localization';

import ModalBody from './ModalBody';

const ActiveResource = ({ saveResourceModal, validateResource, 
  setAlert, hideAlert, closeModal, linkObjects }) => {
  const dispatch = useDispatch();
  const LS = useContext(LocaleContext);
  const count = useSelector(state => state.modal.resources.length);
  const resource = useSelector(state => getActiveResource(state));
  const isLastResource = useSelector(state => canCloseResource(state));
  const showButtons = useSelector(state => state.modal.showButtons);
  const isSaveDisabled = useSelector(state => state.modal.saveDisabled);
  const canLinkMultipleObjects = useSelector(state => state.modal.canLinkMultipleObjects);
  const linkableUris = useSelector(state => state.modal.checkedUris);
  const resources = useSelector(state => state.modal.resources);
  const checkedUris = useSelector(state => state.modal.checkedUris);

  // Save scroll pos when navigating between resources
  useEffect(() => {
    if (count > 0 && resource?.scrollPos) {
      document.querySelector('.modal').scrollTo(0, resource.scrollPos);
    }
  }, [count]);

  if (!resource) {
    return <Loading />;
  }

  const saveAndClose = () => {
    const { isValid, msg } = validateResource();
    const uniquenessMessage = getUniquenessMessage({format: resource.classUri }, LS);
    if (!isValid) {
      setAlert({ header: LS.error.invalidFields, variant: 'danger', contents: msg });
    } else {
      return saveResourceModal(uniquenessMessage);
    }
  };

  const isSearchModal = resources[0] && resources[0]?.searchUri
    ? true
    : false;

  const saveLabel = isSearchModal
    ? LS.modal.saveAndCloseSearch
    : LS.modal.saveAndCloseResource;
  
  const saveDisabled = canLinkMultipleObjects && isSearchModal
    ? checkedUris.length === 0
    : isSaveDisabled || resource.fields.length === 0 || !isLastResource;

  const saveOnSubmit = canLinkMultipleObjects && isSearchModal
    ? () => linkObjects(linkableUris)
    : saveAndClose;

  const closeWithoutSaving = () => {
    if (count > 1) {
      dispatch({type: CLOSE_RESOURCE});
    } else {
      closeModal();
      hideAlert();
    }
  };

  return (
    <Fragment>
      <ModalBody resource={resource} />
      {showButtons && <div className='flex-space-evenly'>
        <SaveButton
          accessKey="s"
          label={saveLabel}
          disabled={saveDisabled}
          onSubmit={saveOnSubmit} />
        <SaveButton
          accessKey="q"
          label={LS.modal.closeWithoutSaving}
          disabled={!isLastResource}
          onSubmit={closeWithoutSaving} />
      </div>}
    </Fragment>
  );
};

export default connect(null, { saveResourceModal, 
  validateResource, setAlert, hideAlert, closeModal, linkObjects })(ActiveResource);